var CreateOrganizationModal;

import OrganizationFormModel from './organization_form_model.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default CreateOrganizationModal = Vue.extend({
  components: {
    'OrganizationFormModel': OrganizationFormModel
  },
  props: {
    parent: {
      type: Object
    },
    childrenAddCallback: {
      type: Function
    },
    profileSchema: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      valid: true,
      description: '',
      name: '',
      applicationStrategy: ''
    };
  },
  template: `<OrganizationFormModel :title='"新增组织"'
                       :prosfileFields='profileSchema.fields'
                       :parent='parent'
                       @valueChange='doRequest'
                       ref="organizationFormModelRef">
</OrganizationFormModel>`,
  methods: {
    valueChanged: function(value) {
      return this.description = value;
    },
    doRequest: function(organization_attributes) {
      return Skylark.Libs.Ajax.post('/admin/organizations', {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          organization: organization_attributes
        },
        success: (data) => {
          newAlertify('创建组织成功', {
            type: 'success'
          });
          this.$refs.organizationFormModelRef.close();
          this.$refs.organizationFormModelRef.resetModal();
          return this.childrenAddCallback(data);
        },
        error: function() {
          return newAlertify('创建组织失败', {
            type: 'error'
          });
        }
      });
    }
  }
});
